export const types = {
  SET_INITIAL_FLOW_INFO: 'FLOW/SET_INITIAL_FLOW_INFO',
  SET_API_FLOW: 'FLOW/SET_API_FLOW',
  SET_NEXT_API: 'FLOW/SET_NEXT_API',
};

export const initialState = {
  actualState: null,
  flowJson: null,
  minderJson: null,
  process: null,
  productOffering: null,
  promotion: null,
  searchParams: null,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const FlowReducer = (state = JSON.parse(JSON.stringify(initialState)), action) => {
  switch (action.type) {
    case types.SET_INITIAL_FLOW_INFO: {
      const {
        process,
        productOffering,
        promotion,
        flowJson,
        minderJson,
        searchParams,
      } = action.payload;

      return {
        ...state,
        process,
        productOffering,
        promotion,
        flowJson,
        minderJson,
        searchParams,
      };
    }
    default:
      return { ...state };
  }
};

export const actions = {
  setInitialFlowInfo: initialFlowInfo => ({
    type: types.SET_INITIAL_FLOW_INFO,
    payload: {
      ...initialFlowInfo,
    },
  }),
};

export default FlowReducer;
